import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ServicesComponent } from './components/services/services.component';
import { HeaderComponent } from './shared/header/header.component';
import { FormDataBasicComponent } from './components/form-data-basic/form-data-basic.component';
import { ErrorComponent } from './shared/error/error.component';
import { AddressComponent } from './components/address/address.component';
import { BalanceComponent } from './components/balance/balance.component';
import { ForeignComponent } from './components/foreign/foreign.component';
import { SignComponent } from './components/sign/sign.component';
import { FinishComponent } from './components/finish/finish.component';
import { ForeignCheckComponent } from './components/foreign-check/foreign-check.component';
import { routeGuard } from './guards/route.guard';
import { WowComponent } from './shared/wow/wow.component';
import { list06Guard } from './guards/list-06.guard';
import { WhatsappValidationComponent } from './components/whatsapp-validation/whatsapp-validation.component';
import { DataConfirmComponent } from './components/data-confirm/data-confirm.component';

export const routes: Routes = [
      {
        path: 'consultor/:internalCode',
        component: HomeComponent,
      },
      {
        path: 'consultor/light/:internalCode',
        component: HomeComponent,
      },
      {
        path: 'foreignCheck',
        component: ForeignCheckComponent,
      },
      // {
      //   path: 'prueba',
      //   component: WowComponent
      // },
      {
        path: 'app',
        component: HeaderComponent,
        children: [
          {
            path: 'whatsapp/:hash',
            component: WhatsappValidationComponent,
          },
          {
            path: 'basic',
            component: FormDataBasicComponent,
            canActivate: [list06Guard]
          },
          {
            path: 'address',
            component: AddressComponent,
            canActivate: [list06Guard]
          },
          {
            path: 'balance',
            component: BalanceComponent,
            canActivate: [list06Guard]
          },
          {
            path: 'foreign',
            component: ForeignComponent,
            canActivate: [list06Guard]
          },
          // {
          //   path: 'data',
          //   component: DataConfirmComponent,
          //   canActivate: [list06Guard]
          // },
          {
            path: 'sign',
            component: SignComponent,
            canActivate: [list06Guard]
          },
          {
            path: 'finish',
            component: FinishComponent,
            canActivate: [list06Guard]
          }
        ]
      },
      {
        path: 'error',
        component: ErrorComponent,
      },
      {
        path: '**',
        component: HomeComponent,
      },
];
